export const sendEvent = value => {

    if(!window.dataLayer) return;

    window.dataLayer.push({'event': value});

}